import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {client} from 'scrumship-client';

client.log('VcmzbF8');

// hide errors while drag and drop in forms
const handleResizeObserverError = (e) => {
    const errorMsg = e?.message || e?.reason?.message || "";
    if (
        errorMsg.includes("ResizeObserver loop completed with undelivered notifications") ||
        errorMsg.includes("ResizeObserver loop limit exceeded")
    ) {
        e.stopImmediatePropagation();
        if (e.preventDefault) e.preventDefault();
    }
};

window.addEventListener('error', handleResizeObserverError, true);
window.addEventListener('unhandledrejection', handleResizeObserverError, true);


ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
